// Core
import React from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Components
import {
  NavigationTabs,
  NavigationTabsProps,
} from '../../../../../../layout/elements/NavigationTabs';

// Modules
import { Sensors } from './Modules/Sensors/Sensors';
import { ValveBank } from './Modules/ValveBank/ValveBank';

// View
import { ComboUnitProps, ComboUnitType } from './ComboUnit.types';
import {
  Container,
  FixedHeader,
  ScrollableContent,
  Separator,
} from './ComboUnit.style';

function ComboUnit({
  className,
  onChangeView,
  unitData,
  edgeStatus,
  selectedView,
  testId,
}: ComboUnitProps): JSX.Element {
  const { t } = useTranslation();

  const changeComboUnitView: NavigationTabsProps['items'] = [
    { key: ComboUnitType.sensors, label: t('view.crusher.maintenance.comboUnit.tabs.sensors') },
    { key: ComboUnitType.valveBank, label: t('common.valveBank') },
  ];

  const renderContent = (): JSX.Element => {
    switch (selectedView) {
      case ComboUnitType.sensors:
        return <Sensors unitData={unitData} edgeStatus={edgeStatus} />;
      case ComboUnitType.valveBank:
        return <ValveBank unitData={unitData} edgeStatus={edgeStatus} />;
      default:
        return <Sensors unitData={unitData} edgeStatus={edgeStatus} />;
    }
  };

  return (
    <Container className={className} data-testid={testId}>
      <FixedHeader>
        <NavigationTabs
          items={changeComboUnitView}
          onClick={onChangeView}
          selected={selectedView}
        />
        <Separator />
      </FixedHeader>
      <ScrollableContent>{renderContent()}</ScrollableContent>
    </Container>
  );
}

export { ComboUnit };
